const NAME_REGEX = /^(.*)\((\d+)\)$/;

export function createCopyName(name: string, otherNames: string[]): string {
  const match = (name || '').trim().match(NAME_REGEX);
  const textName = match?.[1] ?? name;
  let textNumber = parseInt(match?.[2] ?? '-1', 10);
  for (const otherName of otherNames) {
    if (otherName.startsWith(textName)) {
      const match = otherName.match(NAME_REGEX);
      const otherTextNumber = parseInt(match?.[2] ?? '-1', 10);
      if (otherTextNumber >= textNumber) {
        textNumber = otherTextNumber + 1;
      }
    }
  }
  return `${textName} (${textNumber <= 0 ? 1 : textNumber})`;
}

export function arraysEqual(arr1: (string | number)[], arr2: (string | number)[]): boolean {
  return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
}
